export default {
    title: 'Innovation project',
    pageTitle: 'VIEW - INNOVATION PROJECTS'
}
